export const SystemVariable = {
    "USER_ID" : "$UserID",
    "SESSION_ID" : "$SessionID",
    "WEB_KEY ": "$WebKey",
    "JWT" : "$Jwt",
    "REFERRER_AUTHORITY" : "$ReferrerAutority",
    "AUTORITY" : "$Autority",
    "REMOTE_HOST" : "$RemoteHost",
    "WEBSERVER_DATETIME" : "$WebServerDateTime",
}
 